import { Typography } from 'app/components';

import './TagTable.scss';

interface TagTableProps {
  categories: string[];
  align?: 'center' | 'left';
  sortBy?: 'asc' | 'desc';
  setSortBy?: () => void;
  children: React.ReactNode;
}

export const TagTable = ({ categories, setSortBy, sortBy, children, align = 'left' }: TagTableProps) => {
  return (
    <table className="tagging-table">
      <thead>
        <tr>
          {categories.map((category, idx) => (
            <th key={category} onClick={setSortBy} className={`${idx === 0 ? 'row-header' : ''} align-${idx === 0 ? 'left' : align}`}>
              <Typography variant="body-5" fontWeight="bold" color="#547ba2" className="caps">
                {category}
              </Typography>
              {setSortBy && idx === 0 && <i className={`fa-solid fa-arrow-down ${sortBy === 'desc' ? 'rotate-180' : ''}`} />}
            </th>
          ))}
          <th></th>
        </tr>
      </thead>

      <tbody>{children}</tbody>
    </table>
  );
};
